<template>
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <v-container fluid>
                    <v-row align="center" justify="center">
                        <v-card class="login-card" elevation="10">
                            <div class="login-header">
                                <img src="../assets/AiCheckin_Horizontal.png" width="220px" class="logo-animation" alt="Logo AiCheckin">
                            </div>
                            <v-card-text>
                                <v-layout row wrap justify-center>
                                    <v-flex xs10 sm10 lg9>
                                        <v-text-field
                                            color="#2C3E50"
                                            light
                                            label="E-mail"
                                            single-line
                                            outlined
                                            dense
                                            class="input-field"
                                            v-model="user.email" name="email" type="text"
                                            :rules="emailRules"
                                            required
                                            prepend-inner-icon="email"
                                            aria-label="E-mail de login"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9>
                                        <v-text-field
                                            color="#2C3E50"
                                            label="Senha"
                                            single-line
                                            outlined
                                            dense
                                            class="input-field"
                                            v-model="user.password" name="password"
                                            :rules="passwordRules"
                                            required
                                            prepend-inner-icon="lock"
                                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                            :type="show1 ? 'text' : 'password'"
                                            @click:append="show1 = !show1"
                                            @keydown.enter="signin"
                                            aria-label="Senha de login"
                                        />
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9 class="forgot-password">
                                        <a href="#" class="forgot-link" aria-label="Esqueceu a senha">Esqueceu a senha?</a>
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9 v-if="!usuarioLogado">       
                                        <v-btn 
                                            dark 
                                            :loading="loading" 
                                            depressed 
                                            block 
                                            color="#2C3E50" 
                                            class="login-button" 
                                            @click="signin"
                                            aria-label="Entrar no sistema"
                                        >
                                            <span class="login-text">ENTRAR</span>
                                        </v-btn>        
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-row>
                    <br>
                    <div class="footer-area">
                        <div class="company-logo">
                            <a href="https://www.intelitetecnologia.com.br/" target="_blank" aria-label="Site da Intelite Tecnologia">
                                <img src="../assets/LogoBrancoHorizontal.png" width="130px" class="footer-logo" alt="Logo Intelite">
                            </a>
                        </div>
                        <br>
                        <!-- <div class="app-download">
                            <a href="https://aipass.intelite.com.br/app/aipass.apk" target="_blank" class="download-link" aria-label="Baixar aplicativo para Android">
                                <v-icon color="#CE93D8">save_alt</v-icon>
                                <span class="download-text">BAIXAR APP PARA ANDROID</span>
                            </a>
                        </div> -->
                    </div>
                </v-container>
			</div>
		</div>
        <Snackbar ref=chamaSnackbar />
	</div>
</template>

<script>
    import { userKey, baseApiUrl } from '@/global'
    import Snackbar from '../componentes/snackbar.vue'
    import { mapState } from 'vuex'
    import axios from 'axios'
    export default {
        components: {Snackbar},
        name: 'Auth',
        computed: mapState({
            usuarioLogado: state => state.isMenuVisible,
        }),
        data: function() {
            return {
                loading: false,
                countAccess: '',
                userObj: [],
                show1: false,
                token: "",
                userId: "",
                showSignup: false,
                showAlterPass: false,
                userPemission: "",
                user: {},
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail não é válido'
                ],
                nameRules: [
                    v => !!v || 'Nome é obrigatório'
                ],
                passwordRules: [
                    v => !!v || 'Senha é obrigatório'
                ]         
            }
        },

        mounted: function () {
            if (sessionStorage.getItem('accToken') != null)
                this.$router.push({ path: '/home' })
            if (sessionStorage.getItem('userPermission') != null)
                this.$store.dispatch('Permission')
            if (sessionStorage.getItem('accToken') != null)
                this.$store.dispatch('Logar', this.token)
        },

        methods: {
            async signin() {
                this.loading = true
                if ((this.user.email != null) || (this.user.password != null)) {
                    await axios.post(`${baseApiUrl}Usuarios/login`, this.user)
                    .then(res => {
                        this.token = res.data.id
                        this.userId = res.data.userId                    
                        this.VerficiaAdmin()                                                                
                    })
                    .catch(() => { 
                        this.loading = false  
                        var vm = this;          
                        vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e Senha inválidos, corrija e tente novamente!","ERRO")
                    })
                } else {
                    this.loading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os campos de Login e Senha!","ATENÇÃO")
                }
            },

            /* signup() {
                if ((this.user.email != null) || (this.user.username != null) || (this.user.password != null)) {
                    this.$http.post('Usuarios', this.user)
                    .then(() => {
                        this.user = {}
                        this.showSignup = false
                    })
                    .catch(() => {
                    })
                } else {
                    var vm = this;          
                    vm.$refs.chamaSnackbar.snack("warning","Preencha os campos obrigatórios! ") 
                }
            }, */

            Sair() {
                this.$store.dispatch('Sair')
            },
            
            /* async contabilizaAcesso() {
                if (this.userId != '') {
                    this.countAccess = parseInt(this.countAccess) + 1
                    await axios.patch(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`, {"ultimoAcesso" : new Date().toLocaleString(), "countAccesses" : this.countAccess} )
                }
            }, */

            async VerficiaAdmin() {
                if (this.userId != '') {
                    await axios.get(`${baseApiUrl}Usuarios/${this.userId}?access_token=${this.token}`)
                    .then(res => {
                        if (res.data.tipo === "GERENTE" || res.data.tipo === "ADMIN" || res.data.tipo === "CHECKIN" || res.data.tipo === "CHECKOUT" || res.data.tipo === "NOTIFY" && res.data.ativo === true) {
                            sessionStorage.setItem('accToken', this.token)                    
                            this.$store.dispatch('Logar', this.token)
                            this.userPemission = res.data.tipo
                            this.user.username = res.data.nome  
                            this.userObj = res.data
                            if (res.data.countAccesses == null)
                                this.countAccess = 0
                            else
                                this.countAccess = res.data.countAccesses                 
                            sessionStorage.setItem(userKey, JSON.stringify(this.userPemission))
                            sessionStorage.setItem('userPermission', this.userPemission)
                            sessionStorage.setItem('userName', this.user.username)
                            sessionStorage.setItem('user', JSON.stringify(res.data))   
                            this.$store.dispatch('SetUser')                                      
                            this.$store.dispatch('Permission')
                            this.$store.dispatch('SetUserName')
                            this.$router.push({ path: '/home' })
                            this.verificaCompany() 
                            //this.contabilizaAcesso()    
                        } else {
                            this.loading = false                                                              
                            var vm = this;          
                            vm.$refs.chamaSnackbar.snack("warning","Usuário inativo ou sem permissão de acesso!")
                        }
                    })
                    .catch(() => {
                    })
                }
            },
                
            verificaCompany() {
                axios.get(`${baseApiUrl}Empresas?filter[where][id]=${this.userObj.empresaId}&access_token=${this.token}`)
                .then(res => {
                    sessionStorage.setItem('company', JSON.stringify(res.data[0]))   
                    this.$store.dispatch('SetCompany') 
                    this.loading = false                                                 
                })
                .catch(() => {  
                    this.loading = false 
                    var vm = this;          
                    vm.$refs.chamaSnackbar.snack("error","Erro ao consultar Empresa")          
                })
            }
        }
    }
</script>

<style>
    /* LOGIN */
    .limiter {
        width: 100%;
        margin: 0 auto;
        animation: pageFadeIn 0.8s ease;
    }

    .container-login100 {
        width: 100%;  
        min-height: 100vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding: 15px;
        background: #f5f6fa;
        position: relative;
        z-index: 1;
        overflow: hidden;
    }

    .wrap-login100 {
        width: 500px;
        overflow: hidden;
        background: transparent;
    }

    .login-card {
        width: 100%;
        border-radius: 12px !important;
        background-color: #ffffff !important;
        padding: 40px 30px !important;
        box-shadow: 0 8px 16px rgba(0,0,0,0.05) !important;
        transition: all 0.3s ease;
        border: 1px solid rgba(0,0,0,0.05);
    }

    .login-card:hover {
        box-shadow: 0 12px 24px rgba(0,0,0,0.08) !important;
        transform: translateY(-2px);
    }

    .login-header {
        text-align: center;
        margin-bottom: 30px;
    }

    .logo-animation {
        animation: fadeIn 1.5s;
    }

    @keyframes fadeIn {
        0% { opacity: 0; transform: translateY(-20px); }
        100% { opacity: 1; transform: translateY(0); }
    }

    .input-field {
        margin-bottom: 12px !important;
        transition: all 0.3s ease;
    }

    .input-field:hover {
        transform: translateY(-1px);
    }

    .forgot-password {
        text-align: right;
        margin-bottom: 20px;
    }

    .forgot-link {
        font-size: 13px;
        color: #2C3E50;
        text-decoration: none;
        transition: all 0.3s ease;
        font-weight: 500;
    }

    .forgot-link:hover {
        color: #34495E;
        text-decoration: underline;
    }

    .login-button {
        border-radius: 8px !important;
        font-weight: 600;
        letter-spacing: 0.5px;
        height: 48px !important;
        margin-top: 5px;
        transition: all 0.3s ease;
        background: #2C3E50 !important;
        box-shadow: 0 4px 6px rgba(44, 62, 80, 0.1);
        position: relative;
        overflow: hidden;
    }

    .login-button:before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.1),
            transparent
        );
        transition: 0.5s;
    }

    .login-button:hover:before {
        left: 100%;
    }

    .login-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 12px rgba(44, 62, 80, 0.15);
        filter: brightness(105%);
    }

    .login-text {
        font-size: 14px;
        text-transform: uppercase;
    }

    .footer-area {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;
    }

    .company-logo {
        margin-bottom: 10px;
    }

    .footer-logo {
        transition: all 0.3s ease;
        opacity: 0.8;
    }

    .footer-logo:hover {
        transform: scale(1.05);
        opacity: 1;
    }
    
    /* Responsividade para dispositivos menores */
    @media (max-width: 600px) {
        .wrap-login100 {
            width: 100%;
            padding: 0 15px;
        }
        
        .login-card {
            width: 100%;
            margin: 0 auto;
            padding: 30px 20px !important;
        }
        
        .logo-animation {
            width: 180px;
        }
    }

    /* Melhorias na acessibilidade - garantindo contraste */
    .v-text-field:focus-within fieldset,
    .login-button:focus {
        outline: 2px solid #2C3E50 !important;
        outline-offset: 2px;
    }

    .forgot-link:focus {
        outline: 2px solid #34495E !important;
        outline-offset: 2px;
    }

    /* Efeito suave quando clica no botão */
    .login-button:active {
        transform: translateY(1px);
        box-shadow: 0 2px 4px rgba(44, 62, 80, 0.1) !important;
    }

    /* Efeito de transição de página */
    @keyframes pageFadeIn {
        0% { opacity: 0; }
        100% { opacity: 1; }
    }
</style>
